export const scrollTo = (selector: string | HTMLElement, behavior: ScrollBehavior = 'smooth') => {
  const hero = typeof selector === 'string' ? document.querySelector(selector) : selector;
  hero && hero.scrollIntoView({ behavior, block: 'start' });
};

export const createSmoothScrollTo = (selector?: string) => (e: React.MouseEvent<HTMLElement>) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  scrollTo(selector || e.target.getAttribute('href'));
  e.preventDefault(); // Stop Page Reloading
};
